import { connect } from 'react-redux'

import AddressManagerDialog from '../components/address-manager-dialog'

const mapStateToProps = ({ initial: { endpoints, user } }) => ({
    addressesAPIURL: endpoints.addressesAPIURL.replace('user_pk', user.id),
})

export default connect(mapStateToProps)(AddressManagerDialog)
